export default "__VITE_ASSET__Dw4nkiY3__"